import clsx from 'clsx'
import { useRef } from 'react'
import { useButton } from 'react-aria'

type PaginationButtonProps = {
  children: React.ReactNode
  onPress: () => void
  isDisabled?: boolean
  className?: string
}

export default function PaginationButton(props: PaginationButtonProps) {
  const ref = useRef<HTMLButtonElement>(null)

  const { buttonProps } = useButton(props, ref)

  return (
    <button
      onClick={props.onPress}
      className={clsx(
        'radius-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2',
        props.className,
      )}
      ref={ref}
      {...buttonProps}
    >
      {props.children}
    </button>
  )
}
